import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { selectProgram } from "../../../../utils/gtm";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    programData: IProgramWebResponse
}

const WellnessProgramCard = ({ programData, style, ...props }: IProps) => {
    const navigate = useNavigate();

    const CheckBookingAvailableStatus = ({ programPeriod, bookingPeriod, isDisableBooking }: { programPeriod: [string, string], bookingPeriod: [string, string], isDisableBooking: boolean }) => {
        const [startProgram, endProgram] = programPeriod.map(q => dayjs(q))
        const [startBooking, endBooking] = bookingPeriod.map(q => dayjs(q))

        if (dayjs().isAfter(endProgram.endOf('d'))) {
            return <div className="sub-title/st1 secondary/s100" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, width: 80, height: 80, backgroundColor: 'var(--dimd100)', borderRadius: '4px' }}>종료</div>;
        } else if (dayjs().isBefore(startBooking)) {
            return <div className="sub-title/st1 secondary/s100" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, width: 80, height: 80, backgroundColor: 'var(--dimd100)', borderRadius: '4px' }}>오픈 예정</div>;
        } else if (dayjs().isAfter(endBooking) || isDisableBooking) {
            return <div className="sub-title/st1 secondary/s100" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, width: 80, height: 80, backgroundColor: 'var(--dimd100)', borderRadius: '4px' }}>예약 마감</div>;
        } else {
            return <></>;
        }
    }

    const getProgramState = (programPeriod: [string, string], bookingPeriod: [string, string], isDisableBooking: boolean): "오픈예정" | "예약가능" | "예약마감" | "종료" => {
        const [startProgram, endProgram] = programPeriod.map(dayjs);
        const [startBooking, endBooking] = bookingPeriod.map(dayjs);
        const now = dayjs();

        if (now.isAfter(endProgram.endOf("day"))) {
            return "종료";
        }
        if (now.isBefore(startBooking)) {
            return "오픈예정";
        }
        if (now.isAfter(endBooking) || isDisableBooking) {
            return "예약마감";
        }
        return "예약가능";
    };

    const onClickProgram = (id: number, title: string, programPeriod: [string, string], bookingPeriod: [string, string], isDisableBooking: boolean) => {
        const state = getProgramState(programPeriod, bookingPeriod, isDisableBooking);

        selectProgram(title, state)

        navigate(`/wellness-program/${id}`);
    }

    return <div style={{ display: 'flex', paddingBlock: 'var(--space8)', ...style }} onClick={() => onClickProgram(programData.id, programData.title, programData.programPeriod, programData.bookingPeriod, programData.isDisableBooking)} {...props}>
        <div style={{ marginRight: 16, display: 'flex', alignItems: 'center' }}>
            <div style={{ position: 'relative', width: 80, height: 80 }}>
                <img src={programData.thumbnailImageUrl} width={'100%'} height={'100%'} style={{ display: 'block', borderRadius: 'var(--radius4)', objectFit: 'cover' }} />
                <CheckBookingAvailableStatus programPeriod={programData.programPeriod} bookingPeriod={programData.bookingPeriod} isDisableBooking={programData.isDisableBooking} />
            </div>

        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
            <div className="sub-title/st3 base/black" style={{ marginBottom: 4 }}>
                {programData.title}
            </div>

            <div className="body/b1 secondary/s500">
                {programData.isOnline ? '온라인 프로그램' : programData.locationName}
            </div>
            <div className="body/b1 secondary/s500">
                {dayjs(programData.programPeriod[0]).format('YYYY.MM.DD') + ' - ' + dayjs(programData.programPeriod[1]).format('YYYY.MM.DD')}
            </div>
        </div>
    </div>
}

export default WellnessProgramCard;